import { Injectable } from '@angular/core';
import { ListLayout, ListLayoutSingleComponent } from 'gung-list';
import { CustomerContact } from 'gung-standard';
import { JeevesCustomerContactListConfigService } from 'gung-standard-jeeves';
import { CarLinerCustomerContactCardListComponent } from '../components/car-liner-customer-contact-card-list/car-liner-customer-contact-card-list.component';

@Injectable({
  providedIn: 'root'
})
export class CarLinerCustomerContactListConfigService extends JeevesCustomerContactListConfigService {

  getLayouts(): ListLayout<CustomerContact>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => CarLinerCustomerContactCardListComponent,
        getListLayoutComponent: () => ListLayoutSingleComponent,
        getName: () => 'CustomerContacts grid'
      }
    ];
  }
}
